import { Outlet } from 'react-router';
import { UserContextV2 } from '~/app';
import { NavHeader } from '~/components';
import { SiteFooter } from '~/components/footers/SiteFooter';
import { useVaultPageSync } from '~/routing/useVaultPageSync';

/**
 * Vault Header
 *
 * Header for MedCredVault (vault) routes
 * Shows brand logo and user menu
 */
export const VaultHeader = () => {
  const vaultRef = UserContextV2.useSelector((s) => s.context.vaultRef);
  // [MCV-1753] Mounted once in the /vault/* layout route so every client-side navigation reaches
  // the vault machine: notifications, dashboard cards, the collapsed-rail flyout, back/forward and
  // <Navigate> redirects. Called before the early return so hook order stays stable.
  useVaultPageSync();
  if (!vaultRef) {
    return null;
  }

  return (
    <div className="flex flex-col h-full min-h-0">
      <NavHeader />
      <div className="flex-1 min-h-0">
        <Outlet />
      </div>
      <SiteFooter legalLinksInNewTab signedIn />
    </div>
  );
};
